import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const PointsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPoints: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        from: number;
        size: number;
        search: string;
      }
    >({
      query: ({ from, size, search }) => ({
        url:
          `${END_POINTS.getPoint}?from=${from}&size=${size}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getPointsDetail: builder.query<
      CommonResponseType & {
        data: any;
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getPoint}/${id}`,
        method: "GET",
      }),
    }),
    updatePoints: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.getPoint}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deletePoints: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getPoint}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetPointsDetailQuery,
  useLazyGetPointsQuery,
  useUpdatePointsMutation,
  useDeletePointsMutation
} = PointsApi;
